import { jsx as r } from "@emotion/react/jsx-runtime";
import { STATIC_APP_ICONS_ASSET as A } from "../../utils/constants.js";
import { AppIconsValuesEnum as a } from "../../types/components/appIcons.js";
const l = "values", m = "products", _ = ({
  dataTrackId: c,
  name: s,
  height: o = "48",
  width: n = "48",
  className: t
}) => {
  const u = ((e) => Object.values(a).includes(e))(s) ? l : m, p = `${A}/${u}/${s}.svg`;
  return /* @__PURE__ */ r("svg", { "data-track": c, width: n, height: o, children: /* @__PURE__ */ r("image", { xlinkHref: p, width: n, height: o, className: t }) });
};
export {
  _ as AppIcon
};
